<template>
    <mm-select :options="channel_list" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			channel_list:[],
		}
	},
	props:{
		value: {
			require: true,
		},
		no_paused:Boolean,
		filter_list: {
			type: Array,
			default() { return [] }
		}
	},
	watch:{
		async filter_list(list) {
			const all_channel = await this.getAllChannel();
			this.channel_list = all_channel.filter( row => list.indexOf(row.value) === -1);
			if(this.no_paused){
				this.channel_list = this.channel_list.filter(row=>row.status!=='paused')
			}
		}
	},
	async mounted(){
		this.channel_list = await this.getAllChannel();
		if(this.no_paused){
			this.channel_list = this.channel_list.filter(row=>row.status!=='paused')
		}
	},
	methods:{
		sortChanel(x,y){
			return x['account_level'].charCodeAt() - y['account_level'].charCodeAt();
		},
		async getAllChannel() {
			if(!this.$cache['channel_list']){
				const body = await this.$post('/channel/list',{attributes:['channel_id','channel_name','status','account_level']});
				body.rows.sort(this.sortChanel);
				this.$cache['channel_list'] = body.rows.map(v=>{return {status:v.status,value:v['channel_id'],label:v['account_level'].toUpperCase() +':'+v['channel_name']+' ('+v['channel_id']+','+v['status']+')',name:v['channel_name']}});
			}
			return this.$cache['channel_list'];
		}
	}
}
</script>